import { render, staticRenderFns } from "./SkillListTable.vue?vue&type=template&id=39cf43a6&scoped=true"
import script from "./SkillListTable.vue?vue&type=script&lang=js"
export * from "./SkillListTable.vue?vue&type=script&lang=js"
import style0 from "./SkillListTable.vue?vue&type=style&index=0&id=39cf43a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cf43a6",
  null
  
)

export default component.exports